<!--
/**
* @name: List.vue
* @description: 商品列表
* @author: 于海威
* @create: 2020/08/13 10:39:33
* @update: 2020/08/13 10:39:33
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" gutter="10px" @search="onSearch">
      <y-query-item>
        <k-input placeholder="请输入商品名称" clearable v-model="para.goodsNameSale"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入商品货号" clearable v-model="para.goodsCodeSale"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入物料编码" clearable v-model="para.goodsCode"></k-input>
      </y-query-item>
      <y-query-item slot="right">
        <k-dropdown :title="title()" layerMinWidthEqual>
          <k-option @click="onBatchUp">批量上架</k-option>
          <k-option @click="onBatchDown">批量下架</k-option>
          <k-option @click="onBatchSetTag">批量设置标签</k-option>
        </k-dropdown>
      </y-query-item>
      <y-query-item slot="right">
        <k-group>
          <k-group-item style="width: 160px;">
            <k-input clearable placeholder="请输入物料编码" v-model="goodsCode"></k-input>
          </k-group-item>
          <k-group-item>
            <y-button icon="k-icon-add" @click="onAddMateriel">添加商品</y-button>
          </k-group-item>
        </k-group>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false" spaceBetween gutter="10px">
      <y-query-item>
        <k-auto-complete
          ref="au"
          :data="brandList"
          v-model="para.goodsBrandCode"
          key-field="brandCode"
          value-field="gbname"
          search-field="gbname"
          layer-width=""
          placeholder="请选择商品品牌"
          @focus="onFocus"
          @toggle="onToggle"
          @input="onInput"
          :empty="empty"
          :text="text"
        >
          <div slot-scope="{ row }" :key="row.brandCode" class="list">
            <span class="name">{{ row.gbname }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择贸易模式" clearable v-model="para.tradeType">
          <k-option v-for="item in tradeList" :key="item.dvcode" :value="item.dvcode" :label="item.dvname">{{ item.dvname }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择经营方式" clearable v-model="para.managementType">
          <k-option v-for="item in whTypeList" :key="item.dvcode" :value="item.dvcode" :label="item.dvname">{{ item.dvname }}</k-option>
        </k-select>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择上架销售渠道" clearable v-model="para.saleChannelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择排序方式" clearable v-model="para.goodsSortType">
          <k-option v-for="item in goodsSortList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择启停用状态" clearable v-model="para.isEnabled">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <div style="width: 50px;"></div>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <!-- <y-query :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择流转方式" clearable v-model="para.circulationType">
          <k-option v-for="item in circulationTypeList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
    </y-query> -->
    <k-table
      :data="skuList"
      checkboxKey="id"
      :selectedRows.sync="selectedgoodsRows"
      :selectedKeys.sync="goodsIdList"
      hasCheckbox
      height="calc(100vh - 220px)"
      :rightFixedNumber="1"
      :columns="initColumns()"
    ></k-table>
    <k-pagination :total="total" v-if="skuList && skuList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowSale" :title="`商品${goodsCodeSale}销售信息`" layout="header, body, mask, close">
      <y-popup-body size="huge">
        <div>已上架：{{ onSaledChannel }}</div>
        <k-table class="mt-1 mb-2" :data="saleList" :columns="initSaleColumns()"> </k-table>
      </y-popup-body>
    </k-popup>
    <k-popup :show.sync="isShowPrice" title="基础价格信息" layout="header, body, mask, close">
      <y-popup-body size="huge">
        <k-table class="mt-1 mb-2" :data="basicPriceList" :columns="initPriceColumns()"> </k-table>
      </y-popup-body>
    </k-popup>
    <k-popup :show.sync="isShowPlatformPrice" title="平台销售价格信息" layout="header, body, mask, close">
      <y-popup-body size="huge">
        <k-table class="mt-1 mb-2" :data="priceList" :columns="initPlatformPriceColumns()"> </k-table>
      </y-popup-body>
    </k-popup>
    <k-popup :show.sync="isShowBatchUp" @after-ok="onSaveBatch('up')" okText="确认上架" title="商品上架">
      <y-popup-body size="small">
        <y-form contentWidth="400px">
          <y-form-item title="批量上架渠道：">
            <k-select2
              v-model="saleChannelList"
              search-field="name"
              block
              :data="selectChannelList"
              text-field="name"
              key-field="code"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="true"
              placeholder="请选择上架渠道"
            >
            </k-select2>
          </y-form-item>
        </y-form>
        <k-table :data="selectedgoodsRows" checkboxKey="id" :selectedRows.sync="selectedgoodsRows" :selectedKeys.sync="goodsIdList" class="mt-1 mb-2" hasCheckbox :columns="initBatchColumns()">
        </k-table>
      </y-popup-body>
    </k-popup>
    <k-popup :show.sync="isShowBatchDown" @after-ok="onSaveBatch('down')" okText="确认下架" title="商品下架">
      <y-popup-body size="small">
        <y-form contentWidth="400px">
          <y-form-item title="批量下架渠道：">
            <k-select2
              v-model="saleChannelList"
              search-field="name"
              block
              :data="selectChannelList"
              text-field="name"
              key-field="code"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="false"
              placeholder="请选择下架渠道"
            >
            </k-select2>
          </y-form-item>
        </y-form>
        <k-table :data="selectedgoodsRows" checkboxKey="id" :selectedRows.sync="selectedgoodsRows" :selectedKeys.sync="goodsIdList" class="mt-1 mb-2" hasCheckbox :columns="initBatchColumns()">
        </k-table>
      </y-popup-body>
    </k-popup>
    <k-popup :show.sync="isShowBatchSetTag" @after-ok="onSaveBatchTag" okText="添加标签" title="设置标签">
      <y-popup-body size="small">
        <y-form contentWidth="400px">
          <y-form-item title="标签名称：" align="top">
            <k-input :class="css.textarea" tag="textarea" v-model="goodsTagList" block placeholder="请输入，中间用英文逗号隔开"></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_DICT_LIST,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_PAGE,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_ENABLED,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_DISABLED,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SET_RECOMMEND,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BATCH_ON_SHELF,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BATCH_OFF_SHELF,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_SALE,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_BASIC,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SET_TAG_BATCH,
} from "@/assets/modules/apiList";
const initPara = () => ({
  goodsNameSale: "",
  goodsCodeSale: "",
  goodsCode: "",
  goodsBrandCode: "",
  tradeType: "",
  managementType: "",
  saleChannelCode: "",
  goodsSortType: "",
  isEnabled: "",
  circulationType: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      skuList: [],
      goodsCode: "",
      whTypeList: [], //经营方式
      tradeList: [], //贸易模式
      brandList: [],
      channelList: [],
      selectChannelList: [],
      goodsSortList: [
        {
          code: "ASC",
          name: "从高到低",
        },
        {
          code: "DESC",
          name: "从低到高",
        },
      ],
      priceList: [],
      basicPriceList: [],
      goodsTagList: "",
      text: "",
      empty: "",
      saleList: [],
      statusList: [
        { value: true, label: "启用" },
        { value: false, label: "停用" },
      ],
      circulationTypeList: [
        { value: "COMMON", label: "普通" },
        { value: "AREA", label: "按区域流转" },
      ],
      para: initPara(),
      total: 0,
      isLoading: false,
      isShow: false,
      isShowSale: false,
      isShowPrice: false,
      isShowBatchUp: false,
      isShowBatchDown: false,
      isShowBatchSetTag: false,
      isShowPlatformPrice: false,
      goodsCodeSale: "",
      onSaledChannel: "",
      selectedgoodsRows: [],
      goodsIdList: [],
      saleChannelList: [],
      isSaving: false,
      tmpObj: {}, // 临时查看对象
    };
  },
  watch: {
    isShow(v) {
      if (!v) {
        this.tmpObj = {};
      }
    },
    isShowSale(v) {
      if (!v) {
        this.tmpObj = {};
      }
    },
    isShowPrice(v) {
      if (!v) {
        this.tmpObj = {};
      }
    },
    isShowBatchUp(v) {
      if (!v) {
        this.tmpObj = {};
      }
    },
    isShowBatchDown(v) {
      if (!v) {
        this.tmpObj = {};
      }
    },
    isShowBatchSetTag(v) {
      if (!v) {
        this.tmpObj = {};
      }
    },
  },
  methods: {
    onFocus() {},
    onToggle(e) {
      // console.log("toggle", e, this.editPara.goodsCodeSale);
    },
    onInput(text) {},
    // 获取经营方式
    getWhTypeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_DICT_LIST,
        para: { dtkey: "GoodsProperty" },
      }).then((res) => {
        this.whTypeList = res[0].dictValues;
      });
    },
    // 获取贸易模式
    getTradeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_DICT_LIST,
        para: { dtkey: "tradeMode" },
      }).then((res) => {
        this.tradeList = res[0].dictValues;
      });
    },
    // 获取品牌信息
    getBrandList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
        para: {},
      }).then((res) => {
        this.brandList = res;
      });
    },
    // 获取渠道信息
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
        this.channelList.push({
          name: "未分配",
          code: "NOTHING",
          isEnabled: true,
        });
        this.selectChannelList = this.channelList.filter((c) => c.code != "NOTHING");
      });
    },
    initColumns() {
      return [
        {
          name: "商品基本信息",
          field: "",
          style: {
            width: 280,
            "white-space": "normal",
            "word-break": "break-all",
          },
          customRender: (row) => {
            const skuLabel = <span class={row.managementType == "AAA001" ? "self" : "edm"}>{row.managementType == "AAA001" ? "自营" : row.managementType == "AAA004" ? "代发" : "代推"}</span>;
            const skuName = (
              <p class="p">
                {skuLabel}
                <b>&#12288;{row.goodsNameSale}</b>
              </p>
            );
            const hh = <p class="list">商品货号：{row.goodsCodeSale}</p>;
            const bm = <p class="list">物料编码：{row.goodsCode}</p>;
            const ms = <p class="list">贸易模式：{row.tradeTypeName}</p>;
            return (
              <div>
                {skuName}
                {hh}
                {bm}
                {ms}
              </div>
            );
          },
        },
        {
          name: "上架销售渠道",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = [];
            if (row.goodsSaleChannelVOList && row.goodsSaleChannelVOList.length > 0) {
              for (let i = 0; i < row.goodsSaleChannelVOList.length; i++) {
                temp.push(row.goodsSaleChannelVOList[i].saleChannelName);
              }
            }
            const valueStr = <span>{temp.join(",")}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "销售信息",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => (
            <a
              href="javascript:;"
              onClick={(e) => {
                e.stopPropagation();
                this.onViewSale(row);
              }}
            >
              查看详情
            </a>
          ),
        },
        {
          name: "基础价格信息",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => (
            <a
              href="javascript:;"
              onClick={(e) => {
                e.stopPropagation();
                this.onViewPrice(row);
              }}
            >
              查看详情
            </a>
          ),
        },
        {
          name: "平台销售价格信息",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => (
            <a
              href="javascript:;"
              onClick={(e) => {
                e.stopPropagation();
                this.onViewPlatformPrice(row);
              }}
            >
              查看详情
            </a>
          ),
        },
        {
          name: "排序",
          field: "goodsSort",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "设为推荐",
          field: "isGlobalRecommend",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isGlobalRecommend}
              readonly
              onClick={(e) => {
                e.stopPropagation();
                this.onChangeRecommend(row);
              }}
            />
          ),
        },
        {
          name: "状态",
          field: "isEnabled",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={(e) => {
                e.stopPropagation();
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={(e) => {
                  e.stopPropagation();
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const quotaButton = (
              <a
                href="javascript:void(0);"
                onClick={(e) => {
                  e.stopPropagation();
                  this.onQuota(row);
                }}
              >
                配额管理
              </a>
            );
            return (
              <div>
                {viewButton}&#12288;{quotaButton}
              </div>
            );
          },
        },
      ];
    },
    initSaleColumns() {
      return [
        {
          name: "基本信息",
          children: [
            {
              name: "可售渠道",
              field: "",
              style: {
                width: 100,
                textAlign: "center",
              },
              customRender: (row) => {
                let temp = [];
                for (let i = 0; i < row.saleChannelList.length; i++) {
                  temp.push(row.saleChannelList[i].name);
                }
                const valueStr = <span>{temp.join(",")}</span>;
                return <div>{valueStr}</div>;
              },
            },
            {
              name: "仓库",
              field: "wsname",
              style: {
                width: 80,
                textAlign: "center",
                "white-space": "normal",
                "line-height": "18px",
              },
            },
            {
              name: "批次号",
              field: "saleBatchNo",
              style: {
                width: 150,
                textAlign: "center",
                "white-space": "normal",
                "line-height": "18px",
              },
            },
            {
              name: "三方批次号",
              field: "supplierBatchNo",
              style: {
                width: 150,
                textAlign: "center",
                "white-space": "normal",
                "line-height": "18px",
              },
            },
            {
              name: "效期",
              field: "",
              style: {
                width: 80,
                textAlign: "center",
              },
              customRender: (row) => {
                const valueStr = <span>{row.stock.expireDate}</span>;
                return <div>{valueStr}</div>;
              },
            },
            {
              name: "可售规格",
              field: "",
              style: {
                width: 90,
                textAlign: "center",
              },
              customRender: (row) => {
                let temp = [];
                for (let i = 0; i < row.packList.length; i++) {
                  temp.push(row.packList[i].quantity);
                }
                const valueStr = <span>{temp.join("|")}</span>;
                return <div>{valueStr}</div>;
              },
            },
          ],
        },
        {
          name: "库存信息",
          children: [
            {
              name: "总库存",
              field: "",
              style: {
                width: 60,
                textAlign: "center",
              },
              customRender: (row) => {
                const valueStr = <span>{row.stock.inQuantity}</span>;
                return <div>{valueStr}</div>;
              },
            },
            {
              name: "冻结库存",
              field: "",
              style: {
                width: 60,
                textAlign: "center",
              },
              customRender: (row) => {
                const valueStr = <span>{row.stock.freezeQuantity}</span>;
                return <div>{valueStr}</div>;
              },
            },
            {
              name: "有效库存",
              field: "",
              style: {
                width: 60,
                textAlign: "center",
              },
              customRender: (row) => {
                const valueStr = <span>{row.stock.availableQuantity}</span>;
                return <div>{valueStr}</div>;
              },
            },
          ],
        },
      ];
    },
    initPriceColumns() {
      return [
        {
          name: "价格名称",
          field: "priceName",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "价格（单价）",
          field: "unitPrice",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
      ];
    },
    initPlatformPriceColumns() {
      return [
        {
          name: "基本信息",
          children: [
            {
              name: "销售渠道",
              field: "saleChannelName",
              style: {
                width: 100,
                textAlign: "center",
              },
              // customRender: (row) => {
              //   const Name = this.channelList.filter((item) => item.code == row.saleChannelCode).name;
              //   return <div>{row.saleChannelName ? row.saleChannelName : Name}</div>;
              // },
            },
            {
              name: "仓库",
              field: "warehouseName",
              style: {
                width: 80,
                textAlign: "center",
                "white-space": "normal",
                "line-height": "18px",
              },
            },
            {
              name: "批次号",
              field: "batchNo",
              style: {
                width: 150,
                textAlign: "center",
                "white-space": "normal",
                "line-height": "18px",
              },
            },
            {
              name: "三方批次号",
              field: "thirdBatchNo",
              style: {
                width: 150,
                textAlign: "center",
                "white-space": "normal",
                "line-height": "18px",
              },
            },
            {
              name: "效期",
              field: "expiryDate",
              style: {
                width: 100,
                textAlign: "center",
              },
            },
          ],
        },
        {
          name: "价格信息",
          children: [
            {
              name: "规格",
              field: "spec",
              style: {
                width: 60,
                textAlign: "center",
              },
              customRender: (row) => <div class={this.css.box}>{row.specs && row.specs.map((t) => <p class={this.css.tr}>{t.spec}</p>)}</div>,
            },
            {
              name: (
                <div>
                  <div>平台价</div>
                  <div>(单价/总价)</div>
                </div>
              ),
              field: "",
              style: {
                width: 80,
                textAlign: "center",
              },
              customRender: (row) => (
                <div class={this.css.box}>
                  {row.specs &&
                    row.specs.map((t) => (
                      <p class={this.css.tr}>
                        {t.salePrice || "--"}/{t.allPrice || "--"}
                      </p>
                    ))}
                </div>
              ),
            },
            {
              name: (
                <div>
                  <div>店铺销售价</div>
                  <div>(单价/总价)</div>
                </div>
              ),
              field: "",
              style: {
                width: 80,
                textAlign: "center",
              },
              customRender: (row) => (
                <div class={this.css.box}>
                  {row.specs &&
                    row.specs.map((t) => (
                      <p class={this.css.tr}>
                        {t.storeSpecPrice || "--"}/{t.storePrice || "--"}
                      </p>
                    ))}
                </div>
              ),
            },
          ],
        },
      ];
    },
    initBatchColumns() {
      return [
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 200,
          },
        },
      ];
    },
    /** 商品配额操作 */
    onQuota(row) {
      this.$controller.open({
        name: "quotaManagement",
        query: {
          refresh: new Date() - 0,
          id: row.id ? row.id : "",
        },
        title: "配额管理",
      });
    },
    title() {
      return (
        <k-button type="primary">
          批量操作
          <k-icon name="k-icon-arrow-down" />
        </k-button>
      );
    },
    isExistMaterial() {
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST,
        para: { goodsCode: this.goodsCode },
      }).then((res) => {
        if (res) {
          this.$controller.open({
            name: "skuAdd",
            query: {
              refresh: new Date() - 0,
              code: this.goodsCode,
            },
          });
        } else {
          return tip("不存在该物料的扩展信息");
        }
      });
    },
    onAddMateriel() {
      let { tip } = this.$root;
      if (!this.goodsCode) {
        return tip("请输入物料编码查询物料扩展信息是否存在");
      } else {
        this.isExistMaterial();
      }
    },
    onViewPlatformPrice(row) {
      this.goodsCodeSale = row.goodsCodeSale;
      this.getPriceList(row.id);
      this.isShowPlatformPrice = true;
    },
    onViewSale(row) {
      this.goodsCodeSale = row.goodsCodeSale;
      let temp = [];
      if (row.goodsSaleChannelVOList && row.goodsSaleChannelVOList.length > 0) {
        for (let i = 0; i < row.goodsSaleChannelVOList.length; i++) {
          temp.push(row.goodsSaleChannelVOList[i].saleChannelName);
        }
      }
      this.onSaledChannel = temp.join(",");
      this.getSaleList(row.id);
      this.isShowSale = true;
    },
    onViewPrice(row) {
      this.goodsCodeSale = row.goodsCodeSale;
      this.getBasicPriceList(row.id);
      this.isShowPrice = true;
    },
    onEdit(row) {
      this.$controller.open({
        name: "skuAdd",
        query: {
          refresh: new Date() - 0,
          code: row.goodsCode,
          id: row.id,
          edit: 1,
        },
        title: "编辑商品",
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.selectedgoodsRows = [];
      this.goodsIdList = [];
      this.getSkuList();
    },
    onReset() {
      this.para = initPara();
      this.$refs.au.inputText = '';
      this.getSkuList();
    },
    onBatchUp() {
      let { tip } = this.$root;
      this.saleChannelList = [];
      if (this.selectedgoodsRows.length === 0) {
        return tip("请选择需要上架的商品");
      }
      this.isShowBatchUp = true;
    },
    onBatchDown() {
      let { tip } = this.$root;
      this.saleChannelList = [];
      if (this.selectedgoodsRows.length === 0) {
        return tip("请选择需要下架的商品");
      }
      this.isShowBatchDown = true;
    },
    onBatchSetTag() {
      let { tip } = this.$root;
      this.saleGoodsTagList = "";
      if (this.selectedgoodsRows.length === 0) {
        return tip("请选择需要设置标签的商品");
      }
      this.isShowBatchSetTag = true;
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getSkuList();
    },
    onChangeStatus(row) {
      let { id } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.isEnabled ? "停用" : "启用"}该商品？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: row.isEnabled ? NESTLE_GOODS_BACK_SERVER_GOODS_SALE_DISABLED : NESTLE_GOODS_BACK_SERVER_GOODS_SALE_ENABLED,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getSkuList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onChangeRecommend(row) {
      let { goodsCodeSale, isGlobalRecommend } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${isGlobalRecommend ? "不推荐" : "推荐"}该商品？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SET_RECOMMEND,
            para: { goodsCodeSale, isGlobalRecommend: isGlobalRecommend ? 0 : 1 },
          })
            .then(() => {
              this.isLoading = false;
              this.getSkuList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getSkuList() {
      const { para } = this;
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_PAGE,
        para,
      })
        .then((res) => {
          this.skuList = res.pageList;
          this.total = res.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSaveBatch(flag) {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      this.isLoading = true;
      this.isSaving = true;
      let api = flag == "up" ? NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BATCH_ON_SHELF : NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BATCH_OFF_SHELF;
      this.$fetch({
        api: api,
        para: { saleChannelCodeList: this.saleChannelList, saleIdList: this.goodsIdList },
      })
        .then((res) => {
          this.isLoading = false;
          this.isSaving = false;
          flag == "up" ? (this.isShowBatchUp = false) : (this.isShowBatchDown = false);
          this.selectedgoodsRows = [];
          this.goodsIdList = [];
          tip(res);
          this.getSkuList();
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
    onSaveBatchTag() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      if (this.goodsTagList == "" || this.goodsTagList.split(",").length === 0) {
        return tip("请输入商品标签");
      }
      this.isLoading = true;
      this.isSaving = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SET_TAG_BATCH,
        para: { goodsTagList: this.goodsTagList.split(","), saleIdList: this.goodsIdList },
      })
        .then((res) => {
          this.isLoading = false;
          this.isSaving = false;
          this.isShowBatchSetTag = false;
          this.selectedgoodsRows = [];
          this.goodsTagList = "";
          this.goodsIdList = [];
          this.getSkuList();
          tip("商品标签添加成功");
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
    getPriceList(id) {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE,
        para: { id: id },
      }).then((res) => {
        this.priceList = res || [];
      });
    },
    getBasicPriceList(id) {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_BASIC,
        para: { id: id },
      }).then((res) => {
        console.log("res=", res);
        let list = [];
        for (let i in res) {
          console.log("vvvvv", i, res[i]);
          if (i == "retailPrice") {
            list.push({ priceName: "建议零售价", unitPrice: res[i] });
          } else if (i == "rankOne") {
            list.push({ priceName: "等级一", unitPrice: res[i] });
          } else if (i == "rankTwo") {
            list.push({ priceName: "等级二", unitPrice: res[i] });
          }
        }
        this.basicPriceList = list;
      });
    },
    getSaleList(id) {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_SALE,
        para: { id: id },
      }).then((res) => {
        this.saleList = res || [];
      });
    },
  },
  created() {
    this.getWhTypeList();
    this.getTradeList();
    this.getBrandList();
    this.getChannelList();
    this.getSkuList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getSkuList();
    next();
  },
};
</script>

<style lang="postcss" module="css">
.textarea {
  width: 400px !important;
  height: 120px;
  & :global(.k-textarea) {
    height: 120px !important;
    resize: none;
  }
}
.tr {
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #eaecf0;
}
.box p:last-of-type {
  border-bottom: 0px solid #eaecf0;
}
</style>
<style>
.self {
  padding: 3px 7px;
  border: 1px solid #ffa39e;
  background-color: #fff1f0;
  border-radius: 5px;
}
.edm {
  padding: 3px 7px;
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  border-radius: 5px;
}
.p {
  line-height: 22px;
  margin: 14px 0 6px 0;
}
.list {
  margin-top: 5px;
}
.list:last-child {
  margin-bottom: 14px;
}
</style>
